'use strict'; 

let util = require('../core/util'); 




/**
 * cart Line Item request payload
 * @param {String} LANG 
 * @param {Object} lineItem 
 * @param {Object} variantInfo 
 * @param {Object} designerData 
 * @param {String} taxMode
 */
let prepareLineItemRequest = function(LANG, lineItem, variantInfo, designerData, taxMode,init) {
    let customFields =  {};
    let finalSelections = {};

    // preprocess rule engine's final selections, if available
    if (util.typeOf(lineItem.finalSelections, 'array') && lineItem.finalSelections.length) {
        finalSelections = lineItem.finalSelections.reduce((obj, attribute) => {
            obj[attribute.attributeKey] = attribute.attributeValue;
            return obj
        }, {});
    }

    // if request has customFields key use that one
    // This way we can support any custom field
    if (util.typeOf(lineItem.customFields, 'object')) {
        customFields = lineItem.customFields;
    }
    // Note:  lineItemNumber Must be defined otherwise Custom Line Items will not be created
    if (util.typeOf(lineItem.lineItemNumber, 'string')) {
        customFields.lineItemNumber = lineItem.lineItemNumber; 
    }else if(!customFields.lineItemNumber){
        // build own if not suplied
        customFields.lineItemNumber = util.generateLineItemNumber();
    }
    // Allowing defining merchandisingProductName custom field
    if (util.typeOf(lineItem.merchandisingProductName, 'string')) {
        customFields.merchandisingProductName = lineItem.merchandisingProductName; 
    }
    // userSelection = userSelection
    if (util.typeOf(lineItem.userSelection, 'object')) {
        // It should be set of strings
        customFields.userSelection = util.objectToSetOfStrings(lineItem.userSelection); 
        //removing support for v2 since we need discounts on user selctions
        // let userSelectionConverted = util.objectToSetOfStrings(lineItem.userSelection); 
        // customFields = util.getCustomFieldsV2("userSelection",userSelectionConverted,init,customFields); 
    };

    //check for bufferProductionHours
    if (util.typeOf(customFields.bufferProductionHours, 'string')) {
        // It should be number
        customFields = util.getCustomFieldsV2("bufferProductionHours",customFields.bufferProductionHours,init,customFields); 
    };

    //check for production hours
    if (util.typeOf(customFields.mcpProductionHours, 'string')) {
        // It should be number
        customFields = util.getCustomFieldsV2("mcpProductionHours",customFields.mcpProductionHours,init,customFields); 
    };

    //check for buffer artwork serviuce hours
    if (util.typeOf(customFields.bufferArtworkServiceHours, 'string')) {
        // It should be number
        customFields = util.getCustomFieldsV2("bufferArtworkServiceHours",customFields.bufferArtworkServiceHours,init,customFields); 
    };
    
    // If Line Item has variantInfo use it to build required info
    // variantId, mcpSku, variableAttributes
    if (util.typeOf(variantInfo, 'object') && variantInfo.id) {
        // Build Variable Attribute
        let variableAttributes = util.typeOf(lineItem.variableAttributes, 'object') ? util.objectToSetOfStrings(lineItem.variableAttributes) : util.objectToSetOfStrings(buildVariableAttributes(LANG, variantInfo, lineItem.userSelection, lineItem.tenantDefinations, finalSelections, lineItem.variableOverrides));
        customFields = util.getCustomFieldsV2("variableAttributes",variableAttributes,init,customFields);
        
        let mcpSku = variantInfo.attributes.find(row => row.class === 'mcpSKU');
        if(mcpSku && mcpSku.value){
            // add MCP specific custom fields
            customFields.mcpSku = util.getAttributeFirstValue(mcpSku.value, null);
        }

        lineItem.variantId = variantInfo.id;
    
    }else if(!lineItem.variantId){

        throw new Error('Invalid variantInfo / Missing lineItem.variantId'); 
    }
    // If order packet has promisedArrivalDate then use it, else calculate it
    if (util.typeOf(lineItem.promisedArrivalDate, 'string')) {
        customFields = util.getCustomFieldsV2("promisedArrivalDate",lineItem.promisedArrivalDate,init,customFields);
    }

    // add MCP specific custom fields
    if (util.typeOf(lineItem.mcpProductName, 'string')) {
        customFields.mcpPrductName = lineItem.mcpProductName; 
    }

    // Add MCP Designer data if supplied
    if (util.typeOf(designerData, 'object')) {
        // It should be set of strings for v1 and for v2 stringified json
        customFields = util.getCustomFieldsV2("mcpDocumentsSource",util.objectToSetOfStrings(designerData),init,customFields)
    }

    // store same final selection in custom field
    if(!util.typeOf(customFields.finalSelection, 'array')){
        finalSelections = util.objectToSetOfStrings(addVariableOverrides(finalSelections, lineItem.variableOverrides));
        customFields = util.getCustomFieldsV2("finalSelection",finalSelections,init,customFields)
    }
    // Validate required data
    if(!lineItem.productId || !lineItem.variantId || !lineItem.quantity){
        throw new Error('Invalid lineItem info'); 
    }

    var lineItemRequest =  {
        "productId":lineItem.productId, 
        "variantId":lineItem.variantId, 
        "quantity":lineItem.quantity, 
        "custom": {
            "type": {
                "key":"lineItemCustomFields"
            }, 
            "fields":customFields
        }
    }; 

    // Add External price if exists
    if (util.typeOf(lineItem.externalTotalCentAmount, 'number')) {
        if(!lineItem.currencyCode){
            throw new Error('Invalid currencyCode'); 
        }
        // Keeping backward compability 
        if(taxMode == 'ExternalAmount'){
            lineItemRequest.externalTotalPrice =  {
                "price": {
                    // per item price
                    //@todo cTool does not support non-numeric centAmount, it might be zero for now
                    "currencyCode":lineItem.currencyCode, 
                    "centAmount":Math.round(lineItem.externalTotalCentAmount/lineItem.quantity)
                }, 
                "totalPrice": {
                    // total price from external pricing
                    //@todo cTool does not support non-numeric centAmount
                    "currencyCode":lineItem.currencyCode, 
                    "centAmount":Math.round(lineItem.externalTotalCentAmount)
                }

            }; 
        }
        else if(taxMode == 'External'){
            let singleQtyCentAmount = (lineItem.externalTotalCentAmount/lineItem.quantity);
            lineItemRequest.externalPrice = util.getHighPrecisionMoney(lineItem.currencyCode, singleQtyCentAmount);
        }
    }

    // If external tax rate Draft is supplied, use it as it is.
    if(util.typeOf(lineItem.externalTaxRate, 'object')){
        if(!lineItem.externalTaxRate.name || !lineItem.externalTaxRate.country){
            throw new Error('Invalid externalTaxRate'); 
        }
        lineItemRequest.externalTaxRate = lineItem.externalTaxRate;

        //spatel: We need to keep this custom field for backward compability 
        // Use case:  When a "External" mode cart gets merged into "ExternalAmount" we need this field for recalculation of item in "ExternalAmount" mode.
        lineItemRequest.custom.fields.externalTaxRateDraft = JSON.stringify(lineItemRequest.externalTaxRate);
    }
    
    if(taxMode == 'ExternalAmount' && lineItemRequest.externalTaxRate && lineItemRequest.externalTotalPrice){
        lineItemRequest.externalTaxAmount = {
            "totalGross": {
                "currencyCode":lineItem.currencyCode, 
                "centAmount":Math.round(lineItemRequest.externalTotalPrice.totalPrice.centAmount + (lineItemRequest.externalTotalPrice.totalPrice.centAmount * lineItemRequest.externalTaxRate.amount))
            },
            "taxRate": lineItemRequest.externalTaxRate
        };

        
    }

    if(lineItemRequest.externalTaxRate && lineItem.externalTotalCentAmount) {
        // This custom field will help after coupon application
        lineItemRequest.custom.fields.originalLineItemAmountWithTax = {
            "currencyCode": lineItem.currencyCode, 
            "centAmount": Math.round(lineItem.externalTotalCentAmount + (lineItem.externalTotalCentAmount * lineItemRequest.externalTaxRate.amount))
        };
    }

    return lineItemRequest;
}

/**
 * 
 * @param {Array} customLineItems 
 * @param {String} lineItemId 
 * @param {String} currencyCode 
 * @param {String} LANG 
 * @param {Boolean} appendActionName
 * @param {String} taxMode
 */
let prepareCustomLineItemRequest = function(customLineItems, lineItemId, currencyCode, LANG, appendActionName, taxMode){
    if(!util.typeOf(customLineItems, 'array')){
        throw new Error('Invalid CustomLineItems request parameter'); 
    }
    return customLineItems.map(function(customLineItem) {
        if(!util.typeOf(customLineItem.name, 'string') || !util.typeOf(customLineItem.externalTotalCentAmount, 'number')){
            throw new Error('Invalid CustomLineItem name/externalTotalCentAmount parameter'); 
        }
        let customFields =  {};
        // if request has customFields key use that one
        // This way we can support any custom field
        if (util.typeOf(customLineItem.customFields, 'object')) {
            customFields = customLineItem.customFields;
        }

        let slug;
        // for consolidated call, we don't have lineItemId, 
        // it's CMS's responsiblity to add these
        if(util.typeOf(lineItemId, 'string')){
            customFields.lineItemReference = lineItemId;
            slug = customLineItem.name + '_' + lineItemId;
        }
        if(customLineItem.serviceName){
            customFields.serviceName = customLineItem.serviceName;
        }
        var action = {
            "slug": slug,
            "name": {},
            "money": {
                "currencyCode": currencyCode,
                "centAmount": customLineItem.externalTotalCentAmount
            },
            "custom": {
                "type": {
                    "key": "customlineItemCustomFields"
                },
                "fields": customFields
            }
        };
        if(appendActionName){
            action.action = 'addCustomLineItem';
        }
        action.name[LANG] = customLineItem.name;
        
        // if request has quantity
        if(util.typeOf(customLineItem.quantity, 'number')){
            action.quantity = customLineItem.quantity;
        }
        
        // if request has qpShippingCarrierKey
        if(!util.typeOf(customLineItem.qpShippingCarrierKey, 'undefined')){
            action.custom.fields.qpShippingCarrierKey = customLineItem.qpShippingCarrierKey;
        }
        
        if(!util.typeOf(customLineItem.deliveryConstraints, 'undefined')){
            action.custom.fields.deliveryConstraints = customLineItem.deliveryConstraints;
        }

        // if request has externalTaxRate or taxCategory
        if(util.typeOf(customLineItem.externalTaxRate, 'object')){
            action.externalTaxRate = customLineItem.externalTaxRate;
        }
        else if(util.typeOf(customLineItem.taxCategory, 'object')){
            action.taxCategory = customLineItem.taxCategory;
        }else{
            // @todo: spatel: This might be a invalid request
        }

        // Keeping backward compability 
        if(taxMode == 'ExternalAmount' && action.externalTaxRate){
            action.externalTaxAmount = {
                "totalGross": {
                    "currencyCode":currencyCode, 
                    "centAmount":Math.round(action.money.centAmount + (action.money.centAmount * action.externalTaxRate.amount))
                },
                "taxRate": action.externalTaxRate
            };

        }else if(taxMode == 'External'){
            // externalTotalCentAmount itself is single item cost
            action.money = util.getHighPrecisionMoney(currencyCode, customLineItem.externalTotalCentAmount);
        }

        if(action.externalTaxRate) {
            // This custom field will help after coupon application
            action.custom.fields.originalLineItemAmountWithTax = {
                "currencyCode": currencyCode, 
                "centAmount": Math.round(customLineItem.externalTotalCentAmount + (customLineItem.externalTotalCentAmount * action.externalTaxRate.amount))
            };

            //spatel: We need to keep this custom field for backward compability 
            // Use case:  When a "External" mode cart gets merged into "ExternalAmount" we need this field for recalculation of item in "ExternalAmount" mode.
            action.custom.fields.externalTaxRateDraft = JSON.stringify(action.externalTaxRate);
        }
        return action;
    });
}

let prepareCustomLineItemUpdateRequest = (customItem, customLineItemId, currencyCode, taxMode) => {
    let actions = [];

    let updateMoneyAction = {
        action: 'changeCustomLineItemMoney',
        customLineItemId: customLineItemId,
        money: {
            "currencyCode": currencyCode,
            "centAmount": customItem.externalCentAmount
        }
    };
    // Keeping backward compability 
    if(taxMode == 'External'){
        // externalCentAmount itself is single item cost
        updateMoneyAction = {
            action: 'changeCustomLineItemMoney',
            customLineItemId: customLineItemId,
            money: util.getHighPrecisionMoney(currencyCode, customItem.externalCentAmount)
        };
    }

    actions.push(updateMoneyAction, {
        action: 'setCustomLineItemCustomField',
        customLineItemId: customLineItemId,
        name: 'serviceName',
        value: customItem.serviceName
    },{
        action: 'changeCustomLineItemQuantity',
        customLineItemId: customLineItemId,
        quantity: customItem.quantity
    });
    // if request has qpShippingCarrierKey
    if(!util.typeOf(customItem.qpShippingCarrierKey, 'undefined')){
        actions.push({
            action: 'setCustomLineItemCustomField',
            customLineItemId: customLineItemId,
            name: 'qpShippingCarrierKey',
            value: customItem.qpShippingCarrierKey
        });
    }
    
    if(!util.typeOf(customItem.deliveryConstraints, 'undefined')){
        actions.push({
            action: 'setCustomLineItemCustomField',
            customLineItemId: customLineItemId,
            name: 'deliveryConstraints',
            value: customItem.deliveryConstraints
        });
    }
    if(customItem.quantity && customItem.externalTaxRate){
        
        if(taxMode == 'ExternalAmount'){
            let totalCost = Math.round(customItem.externalCentAmount + (customItem.externalCentAmount * customItem.externalTaxRate.amount));
            actions.push({
                action: 'setCustomLineItemTaxAmount',
                customLineItemId: customLineItemId,
                externalTaxAmount: {
                    "totalGross": {
                        "currencyCode":currencyCode, 
                        "centAmount": totalCost
                    },
                    "taxRate": customItem.externalTaxRate
                }
            });
            // This custom field will help after coupon application
            actions.push({
                action: 'setCustomLineItemCustomField',
                customLineItemId: customLineItemId,
                name: 'originalLineItemAmountWithTax',
                value: {
                    "currencyCode": currencyCode, 
                    "centAmount": totalCost
                }
            });
        }
        else {
            // As Can't update externalTaxRate for `ExternalAmount` taxMode
            actions.push({
                action: 'setCustomLineItemTaxRate',
                customLineItemId: customLineItemId,
                externalTaxRate: customItem.externalTaxRate
            });
        }

        actions.push({
            action: 'setCustomLineItemCustomField',
            customLineItemId: customLineItemId,
            name: 'externalTaxRateDraft',
            value: JSON.stringify(customItem.externalTaxRate)
        });
        
    }

    return actions;
}

/**
 * Search All Custom Line Items by Line Item Id
 * @param {Object} cart 
 * @param {String} lineItemId 
 */
let getCustomLineItemsByItemId = function(cart, lineItemId){
    var items = [];
    // search for customLineItems for lineItemId
    if(util.typeOf(cart.customLineItems, 'array')){
        // for loop is faster than filter, so using it
        for(var i = 0, len = cart.customLineItems.length; i < len; i++){
            if(cart.customLineItems[i].custom && cart.customLineItems[i].custom.fields.lineItemReference == lineItemId){
                items.push(cart.customLineItems[i]);
            }
        }
    }
    return items;
}
 /**
 * get Calculated Effective Price of Line Items
 * 
    taxedPrice : {
        "currencyCode": "GBP",
        "totalGrossCentAmount": 5824,// Inc. VAT, will be `null` if tax is not applied to cart yet
        "totalNetCentAmount": 5600,// Without VAT
        "totalTaxCentAmount": 933   //  VAT amount
    }
 * @param {Object} cart 
 * @param {String} lineItemId 
 * @param {String} LANG
 * @param {Array} excludeCustomLineItems
 */
let calculateEffectivePrice = function(cart, lineItemId, LANG, excludeCustomLineItems = []){
    // @todo: for Plateform Tax Mode need to find way to get TaxedTotal of Custom Line Item & Line Item
    var taxedPrice = {};
    if(util.typeOf(cart.lineItems, 'array') && cart.lineItems.length){
        var lineItem = util.searchFirstByKeyValue(cart.lineItems, 'id', lineItemId);
        if(lineItem.id){
            // line Item found
            if(lineItem.taxedPrice){
                taxedPrice = {
                    "currencyCode": lineItem.taxedPrice.totalNet.currencyCode,
                    "totalGrossCentAmount": lineItem.taxedPrice.totalGross.centAmount,
                    "totalNetCentAmount": lineItem.taxedPrice.totalNet.centAmount,
                }
            }else if(lineItem.totalPrice){
                taxedPrice = {
                    "currencyCode": lineItem.totalPrice.currencyCode,
                    "totalGrossCentAmount": null,
                    "totalNetCentAmount": lineItem.totalPrice.centAmount,
                }
            }

            // search custom line items
            let relatedCustomLineItems = getCustomLineItemsByItemId(cart, lineItemId);
            if(relatedCustomLineItems.length){
                for(let i = 0, len = relatedCustomLineItems.length; i < len; i++){
                    if(excludeCustomLineItems.length && excludeCustomLineItems.includes(relatedCustomLineItems[i].name[LANG])){
                        // No need to sum up for excluded Custom Line Items
                        continue;
                    }
                    if(relatedCustomLineItems[i].taxedPrice){
                        taxedPrice.totalGrossCentAmount = (taxedPrice.totalGrossCentAmount ? taxedPrice.totalGrossCentAmount : 0) + relatedCustomLineItems[i].taxedPrice.totalGross.centAmount;
                        taxedPrice.totalNetCentAmount = (taxedPrice.totalNetCentAmount ? taxedPrice.totalNetCentAmount : 0) + relatedCustomLineItems[i].taxedPrice.totalNet.centAmount;
                    }else if(relatedCustomLineItems[i].totalPrice){
                        taxedPrice.totalNetCentAmount = (taxedPrice.totalNetCentAmount ? taxedPrice.totalNetCentAmount : 0) + relatedCustomLineItems[i].totalPrice.centAmount;
                    }
                    
                }
            }
        }

    }
    if(taxedPrice.currencyCode && taxedPrice.totalNetCentAmount){
        taxedPrice.totalTaxCentAmount = util.typeOf(taxedPrice.totalGrossCentAmount, 'number') ? taxedPrice.totalGrossCentAmount - taxedPrice.totalNetCentAmount : null;
    }
    return taxedPrice;
}

/** 
 * Get processed cart response containing line item level and order level effective price
 * 
 * @param {Object} cart
 * @param {Boolean} includeShippingInfo
 * @param {String} LANG
 * @param {Array} excludeCustomLineItems
 * 
*/
let getProcessedCart = function(cart, includeShippingInfo, LANG, excludeCustomLineItems = []){
    let totalGrossCentAmount = null, totalNetCentAmount = null, currencyCode = null, totalTaxCentAmount = null;
    for(let currentIndex = 0, len = (cart.lineItems ? cart.lineItems.length : 0); currentIndex < len; currentIndex++){
        let effectivePrice = calculateEffectivePrice(cart, cart.lineItems[currentIndex].id, LANG, excludeCustomLineItems);
        cart.lineItems[currentIndex]['effectivePrice'] = effectivePrice;

        //Update the order level effective price
        if(!currencyCode){
            //for first time
            currencyCode = effectivePrice.currencyCode;
        }
        totalNetCentAmount = getUpdatedTotalPrice(totalNetCentAmount, effectivePrice['totalNetCentAmount']);
        totalGrossCentAmount = getUpdatedTotalPrice(totalGrossCentAmount, effectivePrice['totalGrossCentAmount']);
    }
    if (includeShippingInfo && cart.shippingInfo &&
        cart.shippingInfo.taxedPrice &&
        cart.shippingInfo.taxedPrice.totalGross &&
        cart.shippingInfo.taxedPrice.totalGross.centAmount
    ) {
        totalNetCentAmount = getUpdatedTotalPrice(totalNetCentAmount, cart.shippingInfo.taxedPrice.totalNet.centAmount);
        totalGrossCentAmount = getUpdatedTotalPrice(totalGrossCentAmount, cart.shippingInfo.taxedPrice.totalGross.centAmount);
    }

    // calculate Tax amount only when cart has items & tax applied
    if(currencyCode && totalGrossCentAmount){
        totalTaxCentAmount = util.typeOf(totalGrossCentAmount, 'number') ? totalGrossCentAmount - totalNetCentAmount : null;
    }

    // Update cart level info
    cart['effectivePrice'] = {
        "currencyCode": currencyCode,
        "totalGrossCentAmount": totalGrossCentAmount,
        "totalNetCentAmount": totalNetCentAmount,
        "totalTaxCentAmount": totalTaxCentAmount
    };

    return cart;
};

let getUpdatedTotalPrice = function(totalPrice, priceToAdd){
    if(totalPrice != null){
        if(priceToAdd == null){
            return totalPrice;
        } else {
            //If the existing total amount is null, but the amount to be added in non-null numeric value, return the price to be added
            return (totalPrice + priceToAdd);
        }
    } else {
        if(priceToAdd == null){
            return null;
        } else {
            //If the existing total amount is null, but the amount to be added in non-null numeric value, return the price to be added
            return priceToAdd;
        }
    }
};

/**
 * Search within states for Specific StateType
 * @param {Array} states 
 * @param {String} stateName 
 * @param {String} stateType 
 */
let getFilteredStateByType = function(states, stateName, stateType){
    var _state = {};
    if (!util.typeOf(states, 'array')) {
        return _state;
    }
    for(var i = 0, len = states.length; i < len; i++){
        if(states[i].type == stateType && states[i].key == stateName){
            _state = states[i];
            break;
        }
    }
    return _state;
};

let searchItemByCustomFieldValue = function(items, customFieldName, customFieldValue){
    var _item = {};
    if (!util.typeOf(items, 'array')) {
        return _item;
    }
    for(var i = 0, len = items.length; i < len; i++){
        if(items[i].custom && items[i].custom.fields[customFieldName] && items[i].custom.fields[customFieldName] == customFieldValue){
            _item = items[i];
            break;
        }
    }
    return _item;
};

/**
 * Build set Tax Amount actions 
 * @param {Object} cart 
 */
let buildExternalTaxAmountRequests = (cart) => {
    let actions = [];
    if(!cart.id){
        return actions;
    }

    // prepare for lineItems
    for(let i = 0, len = cart.lineItems.length; i < len; i++){
        if(cart.lineItems[i].custom && cart.lineItems[i].custom.fields && cart.lineItems[i].custom.fields.externalTaxRateDraft && cart.lineItems[i].totalPrice){
            let externalTaxRate = null;
            try{
                externalTaxRate = JSON.parse(cart.lineItems[i].custom.fields.externalTaxRateDraft);
            }catch(e){}

            let externalTaxAmount = {
                "totalGross": {
                    "currencyCode":cart.lineItems[i].totalPrice.currencyCode, 
                    "centAmount":Math.round(cart.lineItems[i].totalPrice.centAmount + (cart.lineItems[i].totalPrice.centAmount * externalTaxRate.amount))
                },
                "taxRate": externalTaxRate
            };
            
            actions.push({
                "action": "setLineItemTaxAmount",
                "lineItemId": cart.lineItems[i].id,
                "externalTaxAmount": externalTaxAmount
            });
        }
    }

    // prepare for customLineItems
    for(let i = 0, len = cart.customLineItems.length; i < len; i++){
        if(cart.customLineItems[i].custom && cart.customLineItems[i].custom.fields && cart.customLineItems[i].custom.fields.externalTaxRateDraft && cart.customLineItems[i].totalPrice){
            let externalTaxRate = null;
            try{
                externalTaxRate = JSON.parse(cart.customLineItems[i].custom.fields.externalTaxRateDraft);
            }catch(e){}

            let externalTaxAmount = {
                "totalGross": {
                    "currencyCode":cart.customLineItems[i].totalPrice.currencyCode, 
                    "centAmount":Math.round(cart.customLineItems[i].totalPrice.centAmount + (cart.customLineItems[i].totalPrice.centAmount * externalTaxRate.amount))
                },
                "taxRate": externalTaxRate
            };
            
            actions.push({
                "action": "setCustomLineItemTaxAmount",
                "customLineItemId": cart.customLineItems[i].id,
                "externalTaxAmount": externalTaxAmount
            });
        }
    }

    return actions;
};

/**
 * Build set of variableAttributes
 * 
 * @param {String} LANG 
 * @param {Object} variantInfo 
 * @param {Object} userSelection 
 * @param {Array} tenantDefinations 
 * @param {Object} finalSelections 
 * @param {Array} variableOverrides 
 * @returns {Object}
 */
let buildVariableAttributes = (LANG, variantInfo, userSelection, tenantDefinations, finalSelections, variableOverrides = []) => {
    // variableAttributes = userSelection + inputTip.variable: true
    let variableAttributes = {};
    for(var i = 0, len = variantInfo.attributes.length; i < len; i++){
        var attribute = variantInfo.attributes[i];

        if(userSelection[attribute.label[LANG]] !== undefined){
            // Use value from user selection
            variableAttributes[attribute.label[LANG]] = userSelection[attribute.label[LANG]];
        }else{
            // If not user selectable, then also send one value
            // for inputTip.variable: true
            // Disabling logic to pass on variable attributes, includeOnOrder will be used.
            if(attribute.variable){
                // if supplied use rule engine's final selections
                if(finalSelections[attribute.label[LANG]] !== undefined){
                    variableAttributes[attribute.label[LANG]] = finalSelections[attribute.label[LANG]];
                }
                else if(attribute.value){
                    variableAttributes[attribute.label[LANG]] = util.getAttributeFirstValue(attribute.value, null);
                }
            }
        }
    }

    // if `tenantDefinations` is supplied and attribute has `includeOnOrder`: true then 
    // include those attributes also in `variableAttributes` if they exists in `finalSelections`
    if(util.typeOf(tenantDefinations, 'array')){
        for (let i = 0, len = tenantDefinations.length; i < len; i++) {
            let defination = tenantDefinations[i];
            if(
                util.typeOf(defination.includeOnOrder, 'boolean') && 
                defination.includeOnOrder && 
                defination.attributeKey &&
                variableAttributes[defination.attributeKey] === undefined &&
                finalSelections[defination.attributeKey] !== undefined
            ){
                variableAttributes[defination.attributeKey] = finalSelections[defination.attributeKey];
            }
        }
    }

    // Overwrite Variable Attribute if exists in `variableOverrides` set
    if (util.typeOf(variableOverrides, 'array') && variableOverrides.length) {
        variableOverrides.map(function (item) {
            variableAttributes[item.key] = item.value;
        });
    }

    // Start passing `Production Time` from final Selection if exists
    if(util.typeOf(variableAttributes['Production Time'], 'undefined') && !util.typeOf(finalSelections['Production Time'], 'undefined')){
        variableAttributes['Production Time'] = finalSelections['Production Time'];
    }

    return variableAttributes;
}

let addVariableOverrides = (finalSelection, variableOverrides) => {
    // Overwrite Variable Attribute if exists in `variableOverrides` set
    if (util.typeOf(variableOverrides, 'array') && variableOverrides.length) {
        variableOverrides.map(function (item) {
            finalSelection[item.key] = item.value;
        });
    }

    return finalSelection;
}
/**
 * 
 * @param {String} productKey 
 * @param {String} quantity 
 * @param {String} merchantId 
 * @param {Object} finalSelections 
 * @param {String} bufferArtworkServiceHours 
 * @param {String} bufferProductionHours 
 * @param {String} productionTime 
 * @param {String} carrierServiceKeys 
 * @param {Object} address 
 * @param {String} deliveryDateFromPricing 
 * @param {String} fulfillmentLocationId 
 * @param {String} productTypeId 
 * @param {String} now 
 */
let getUpdatedArrivalDate= async (url,productKey, quantity, merchantId, finalSelections,
    bufferArtworkServiceHours, bufferProductionHours, productionTime,
    carrierServiceKeys,
    address, deliveryDateFromPricing,
    fulfillmentLocationId, productTypeId,now,callViaItemDelivery) =>{
    let request = {
        "productKey": productKey, 
        "quantity": quantity, 
        "merchantId": merchantId, 
        "variableAttributes": finalSelections, 
        "bufferArtworkServiceHours": bufferArtworkServiceHours, 
        "bufferProductionHours": bufferProductionHours, 
        "productionTime": productionTime, 
        "requestDateTime": now
    }
    if(util.typeOf(address, 'object')){
        request.address = address;
    }
    if(util.typeOf(carrierServiceKeys, 'array')){
        request.carrierServiceKeys = carrierServiceKeys;
    }
    if(util.typeOf(deliveryDateFromPricing, 'string')){
        request.deliveryDateFromPricing = deliveryDateFromPricing;
    }
    if (util.typeOf(fulfillmentLocationId, 'string')) {
        request.fulfillmentLocationId = fulfillmentLocationId;
    }
    if (util.typeOf(productTypeId, 'string')) {
        request.productTypeId = productTypeId;
    }
    if (util.typeOf(callViaItemDelivery, 'number')) {
        request.callViaItemDelivery = callViaItemDelivery;
    }
    return  await util.makePostRequest(url, request);
}

let getCustomLineItems=(shoppingListData,lineItemId)=>{
    let customLineItemArray=[];
    _.forEach(shoppingListData.textLineItems,function(customLineItem){
            if(customLineItem.custom!=null && customLineItem.custom.fields.lineItemReference!=null && customLineItem.custom.fields.lineItemReference==lineItemId){
               customLineItemArray.push(customLineItem);
            }
    });
    return customLineItemArray.map((eachCustomItem)=>{
        var request={};
        request.name=eachCustomItem.name.en;
        request.externalTotalCentAmount=eachCustomItem.custom.fields.originalLineItemAmount.centAmount/eachCustomItem.quantity;
        request.quantity=eachCustomItem.quantity;
        request.externalTaxRate=JSON.parse(eachCustomItem.custom.fields.externalTaxRateDraft);
        request.serviceName=eachCustomItem.custom.fields.serviceName;
        return request;
    });
}

let getCustomFieldVersion = (initParams)=>{
    return initParams.supportV2?"v2":"v1";
}



module.exports = {
    prepareLineItemRequest: prepareLineItemRequest,
    prepareCustomLineItemRequest: prepareCustomLineItemRequest,
    getCustomLineItemsByItemId: getCustomLineItemsByItemId,
    prepareCustomLineItemUpdateRequest,
    calculateEffectivePrice: calculateEffectivePrice,
    getProcessedCart: getProcessedCart,
    getFilteredStateByType: getFilteredStateByType,
    searchItemByCustomFieldValue: searchItemByCustomFieldValue,
    buildExternalTaxAmountRequests,
    buildVariableAttributes,
    getUpdatedArrivalDate,
    getCustomLineItems,
    getCustomFieldVersion
}


// WEBPACK FOOTER //
// ./src/order/CartUtility.js